export const uiconfig = {
  resposiveSize: "670px",
};
